(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-widget-2-board-games"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-2-candles"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-2-christmas"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-2-diamond-dotz"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-2-marci-mugs"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-2-memory-book"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-2-plush"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-2-puzzles"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-2-recordable-books"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-2-willow-tree-figurines"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-2-woodwick-candles"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-2"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-3-board-games"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-3-candles"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-3-christmas"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-3-diamond-dotz"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-3-figuredart"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-3-marci-mugs"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-3-memory-book"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-3-outdoor"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-3-plush"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-3-puzzles"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-3-recordable-books"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-3-willow-tree-figurines"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-3-woodwick-candles"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-3"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-board-games"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-candles"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-christmas"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-diamond-dotz"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-marci-mugs"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-memory-book"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-plush"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-puzzles"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-recordable-books"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-willow-tree-figurines"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget-woodwick-candles"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-widget"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-anime-products"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-anime-products2"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-anime-products3"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-anime-products4"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-christmasmovies-products"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-christmasmovies-products2"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-christmasmovies-products3"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-christmasmovies-products4"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-classicchristmas-products"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-classicchristmas-products2"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-classicchristmas-products3"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-classicchristmas-products4"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-classicchristmas-products5"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-classicchristmas-products6"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-faithinspiration-products"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-faithinspiration-products2"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-faithinspiration-products3"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-faithinspiration-products4"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-gaming-products"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-gaming-products2"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-gaming-products3"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-gaming-products4"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-halloween-products"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-halloween-products2"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-halloween-products3"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-halloween-products4"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-holidayhumor-products"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-holidayhumor-products2"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-holidayhumor-products3"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-holidayhumor-products4"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-lightsoundmotion-products"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-lightsoundmotion-products2"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-lightsoundmotion-products3"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-lightsoundmotion-products4"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-lightsoundmotion-products5"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-lovebabyfamily-products"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-lovebabyfamily-products2"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-lovebabyfamily-products3"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-lovebabyfamily-products4"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-miniature-products"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-miniature-products2"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-miniature-products3"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-miniature-products4"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-moviestv-products"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-moviestv-products2"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-moviestv-products3"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-moviestv-products4"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-scififantasy-products"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-scififantasy-products2"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-scififantasy-products3"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-scififantasy-products4"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-seriesfavorites-products"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-seriesfavorites-products2"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-seriesfavorites-products3"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-seriesfavorites-products4"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepsake-seriesfavorites-products5"]) return;
  try {
    
    $('.carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
	  pauseOnHover: true,
	  puaseOnFocus: true,
	  infinite: true,
	  arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            puaseOnFocus: true,
            infinite: true
          }
        }
      ]
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-popup"]) return;
  try {
    
 
// Check if the popup has already been shown in the session
if (!sessionStorage.getItem('popupShown')) {
  // Show the popup
  $('#mm-popup').show();

  // Set a flag in session storage to indicate that the popup has been shown
  sessionStorage.setItem('popupShown', false);
}


// Close the popup when the close button is clicked
$('#mm-popup #close-popup').click(function() {
  $('#mm-popup').hide();
});

  } catch(e) { console.error(e); }
})();
})();
